import availableGenders from '@/helpers/availableGendersHelper'

export default {
    castSearch() {
        return this.$store.state.castSearch
    },
    availableJobTypes() {
        switch (this.filters.category) {
            case 'casting':
                return this.availableCastingJobTypes
            case 'master_of_ceremonies':
                return this.availableMasterOfCeremoniesJobTypes
            case 'event_support':
                return this.availableEventSupportJobTypes
            case 'bars_restaurants':
                return this.availableBarsRestaurantsJobTypes
            default:
                return []
        }
    },
    availableGenders() {
        availableGenders.unshift({
            label: 'Todos',
            code: null
        })

        return availableGenders
    },

    favoriteIds() {
        return this.$store.state.session.favoriteWorkProfiles.map(profile => {return profile['@id']})
    }
}

